export const getPicture = state => state.Quest;
